export default "__VITE_ASSET__YVheQBub__"